import { useState } from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableHeadCell,
  TableRow,
  TableCell,
  Button,
  Icon,
} from '@safedns/skydns-ui-react-lib';

import sprite from '../../icons/sprite.svg';

import { useGetUserQuery, useGetAuthKeyQuery } from '../../services/ADapi';

import DeleteAuthKeyDialog from './DeleteAuthKeyDialog';
import { actionTableCellStyle } from '../../styles/tableStyles';

const AuthKeyView = ({ isAgentBuilding }) => {
  const {
    data: { user_id },
  } = useGetUserQuery();
  const [isDialogShow, setDialogState] = useState(false);

  const dialogStateHandler = () => {
    setDialogState((prevState) => !prevState);
  };

  const { data: authKey } = useGetAuthKeyQuery(user_id);

  return (
    <>
      <TableContainer sx={{ paddingBottom: 24 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableHeadCell sx={{ textAlign: 'left' }}>Ключи</TableHeadCell>
              <TableHeadCell sx={{ textAlign: 'left' }}>Создан</TableHeadCell>
              <TableHeadCell sx={{ textAlign: 'left' }}>Статусы</TableHeadCell>
              <TableHeadCell sx={actionTableCellStyle}></TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell scope="row">{authKey.auth_key}</TableCell>
              <TableCell>{authKey.updated}</TableCell>
              <TableCell>Активный</TableCell>
              <TableCell align="center" sx={actionTableCellStyle}>
                <Button
                  variant="icon"
                  isIconButton
                  onClick={dialogStateHandler}
                  isDisabled={isAgentBuilding}
                >
                  <Icon id="remove" sprite={sprite} width={22} height={22} />
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {isDialogShow ? (
        <DeleteAuthKeyDialog
          isDialogShow={isDialogShow}
          onDialogAction={dialogStateHandler}
        />
      ) : null}
    </>
  );
};

export default AuthKeyView;
